import React, { useState } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    setDone(true);
    setEmail("");
    setTimeout(() => setDone(false), 4000);
  };
  return (
    <section className="bg-navy-dark">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-14 text-center lg:px-8">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-white md:text-3xl">
            Join the Cyberfit Club
          </h2>
          <p className="mt-2 text-sm text-white/60">
            Be the first to hear about exclusive member-only sales, new arrivals and training tips.
          </p>
        </div>
        <form onSubmit={submit} className="flex w-full max-w-md items-center gap-2">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="h-12 flex-1 rounded-full border border-white/20 bg-white/10 px-5 text-sm text-white outline-none placeholder:text-white/40 focus:border-brand"
          />
          <button
            type="submit"
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand text-white transition-colors hover:bg-brand-dark"
            aria-label="Subscribe"
          >
            <ArrowRight size={20} />
          </button>
        </form>
        {done && (
          <p className="flex items-center gap-2 text-sm font-medium text-green-400">
            <CheckCircle2 size={16} /> You&rsquo;re in! Welcome to the club.
          </p>
        )}
      </div>
    </section>
  );
}
